'use client'
import AccordionLayout from '@/components/AccordionLayout'
import { Link } from 'navigation'
import { useMessages, useTranslations } from 'next-intl'
import { useParams } from 'next/navigation'
import React, { useState } from 'react'

const PriveFaq = () => {
  const {locale} = useParams();
  const t = useTranslations('privePage.priveFaq')
  const messages = useMessages()
  const faqs = Object.keys(messages['privePage']['priveFaq']['FAQDetails'])
  const [isExpandedIndex, setIsExpandedIndex] = useState(null)
  const handleToggleAccordion = (index) => {
    setIsExpandedIndex(isExpandedIndex === index ? null : index)
  }

  return (
    <section>p
      <div className='container px-[15px] md:px-0 py-12 md:py-24'>
        <h3 className='heading-common mb-12'>{t('title')}</h3>
        {faqs.map((faq, index) => {
              
              const answerKey = `FAQDetails.${faq}.answer`
          return (
            <AccordionLayout
              priveFaq = {true}
              key={faq}
              title={t(`FAQDetails.${faq}.question`)}
              content={t.rich(answerKey, {
                a: (chunks) => (
                  <Link
                    target='_self'
                    className='text-blue-600 hover:underline'
                    href={`https://rolzo.com/${locale === 'pt-BR' ? 'pt' : locale}/${chunks}`}
                  >
                    {`https://rolzo.com/${locale === 'pt-BR' ? 'pt' : locale}/${chunks}`}
                  </Link>
                ),
              })}
              index={index}
              isExpanded={isExpandedIndex === index}
              onToggle={handleToggleAccordion}
            />
          )
        })}
      </div>
    </section>
  )
}

export default PriveFaq
